import SvgIcon from "@mui/material/SvgIcon";
import styled from "@mui/styled-engine-sc";

const CustomSvg = styled((props) => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} />
))`
  ${({ theme }) => `
    width:20px;
    height:20px;

    ${theme.breakpoints.down("md")} {
      width:24px;
      height:24px;
    }

    &.small {
      width:16px;
      height:16px;
    }
  `}
`;

export const SvgMyAccount = (props) => {
  const { className = "" } = props;

  return (
    <CustomSvg {...{ className }}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M10.5 11.9375C13.2889 11.9375 15.5776 13.0033 16.7384 13.6678C17.5841 14.1521 18 15.0467 18 15.9219V17.5625C18 18.0803 17.5803 18.5 17.0625 18.5H3.9375C3.41974 18.5 3 18.0803 3 17.5625V15.9219C3 15.0467 3.4159 14.1521 4.26159 13.6678C5.42244 13.0033 7.71112 11.9375 10.5 11.9375ZM10.5 13.8125C8.16944 13.8125 6.21229 14.7124 5.1936 15.2956C5.01497 15.3979 4.875 15.6167 4.875 15.9219V16.625H16.125V15.9219C16.125 15.6167 15.985 15.3979 15.8064 15.2956C14.7878 14.7124 12.8305 13.8125 10.5 13.8125ZM10.5 3.5C12.571 3.5 14.25 5.17893 14.25 7.25C14.25 9.32103 12.571 11 10.5 11C8.42893 11 6.75 9.32103 6.75 7.25C6.75 5.17893 8.42893 3.5 10.5 3.5ZM10.5 5.375C9.46444 5.375 8.625 6.21447 8.625 7.25C8.625 8.28553 9.46444 9.125 10.5 9.125C11.5356 9.125 12.375 8.28553 12.375 7.25C12.375 6.21447 11.5356 5.375 10.5 5.375Z"
        fill="black"
      />
    </CustomSvg>
  );
};
